<template>
  <div class="flex w-full min-h-screen items-center">
    <div
      class="flex flex-col border border-green-500 text-justify text-custom-content w-full relative"
    >
      <span
        class="absolute -top-4 left-1 bg-custom-background text-white text-2xl px-2"
        >About Me</span
      >
      <div
        class="flex rounded-full w-40 h-40 mx-auto overflow-hidden mt-4 mb-2"
      >
        <img
          src="@/assets/image/rdanang.jpg"
          alt=""
          srcset=""
          class="object-cover h-full w-full"
        />
      </div>
      <div class="mx-auto pb-1 lg:text-xl lg:tracking-normal lg:leading-normal">
        Hello there Internet Fellas!
        <img
          src="@/assets/image/waving-hand-joypixels.gif"
          alt="hi-gif-from-joypixels"
          class="inline w-5 pb-2"
        />
      </div>
      <div class="tracking-tighter leading-tight lg:text-lg lg:tracking-normal">
        <p class="px-4 pb-3">
          My name is Ridho Danang Sanyoto, Well known as Mas Danang, but people
          also call me Iyoy, born on late April 1999, I love matrial arts,
          playing games, and anything that realted to tech, especially when I
          have to built it from scratch, because with that way I know how it
          works, My intrest on Web Development was started when I was Junior
          High School Student, Maybe because I spent a lot of time at Internet
          Caffe back then, So I choose Software Engineering for my Vocational
          High School Majority to learn more about it, and finaly start using
          Framework when I develop my final assigment for Bachelor Degree, I may
          not good at competitive programming, but i got the job done anyway.
        </p>
        <div
          class="px-4 flex flex-col text-xs sm:text-sm tracking-normal lg:text-lg"
        >
          <span>Language, Tools and Concept :</span>
          <div class="flex flex-row justify-between pb-2">
            <ul class="list-inside list-disc">
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">HTML</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">CSS</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">PHP</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">JavaScript</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">TypeScript</span>
              </li>
            </ul>
            <ul class="list-inside list-disc">
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">Laravel</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">NestJS</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">TailwindCSS</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">React/Vue</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">Next/Nuxt</span>
              </li>
            </ul>
            <ul class="list-inside list-disc">
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">MySQL</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">MongoDB</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">Nginx</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">VSCode</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">Linux</span>
              </li>
            </ul>
            <ul class="list-inside list-disc">
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content"
                  >Git, Github, GitLab</span
                >
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">Postman, Swagger</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">REST API</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">SPA & PWA</span>
              </li>
              <li class="text-green-500">
                <span class="-ml-2 text-custom-content">AWS S3 / GCP </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped></style>
